import { render } from "./form.vue?vue&type=template&id=a50c2cf6&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=a50c2cf6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/official-accounts/official-accounts/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50c2cf6"]])

export default __exports__